import $ from 'jquery';
import 'slick-carousel';
export default {
  init: function init() {},
  finalize: function finalize() {
    var self = this;
    var $mainvisual = $('#p-top-album-slider');

    if ($mainvisual.get(0)) {
      $mainvisual.slick({
        autoplay: true,
        infinite: true,
        arrows: false,
        dots: false,
        swipe: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        autoplaySpeed: 0,
        cssEase: 'linear',
        speed: 15000,
        centerMode: true,
        variableWidth: true,
        slidesToShow: 4
      });
    }

    $('.js-top-entry-toggle').on('click', function () {
      var target = $(this).attr('data-target');
      $(this).parent().attr('data-status', target);
      $('.js-top-entry-target').attr('data-status', target);
    });
    setTimeout(function () {
      self.asyncGoogleMap();
    }, 1000);
  },
  asyncGoogleMap: function asyncGoogleMap() {
    $('.js-google-map').each(function () {
      var map = $(this).data('map');
      $(this).after(map);
    });
  }
};